import axios from 'axios';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import React, { useEffect, useState } from 'react'
import { getApiHeader } from 'utlis/commonfunctions';
import DatePicker from 'react-datepicker';
import { WidgetInput } from "react-addressfinder";
import "react-addressfinder/dist/widget.css";
import 'react-datepicker/dist/react-datepicker.css';
import { Backdrop, CircularProgress } from '@mui/material';
import CustomModal from 'layouts/CommonModal';
import ActivationHead from './ActivationHead';
import Loader from "./loader";
import swal from 'sweetalert';

const SERVER_URL = process.env.REACT_APP_API_URL;


function IdValidation({ nextStep, prevStep, commonSession, handleDvsEntry, dvs_Details }) {

    console.log(dvs_Details);

    // Set id_type and imageKey based on dvs_Details.id_type
    let id_type = null;
    let imageKey = null;
    if (dvs_Details?.id_type === "2") { 
        id_type = 'driving'; 
        imageKey = 2; 
    }else if (dvs_Details?.id_type === "1") { 
        id_type = 'passport'; 
        imageKey = 1;  
    }else if (dvs_Details?.id_type === "3") { 
        id_type = 'medicare'; 
        imageKey = 3; 
    }

    var exaddress = '';
    if(dvs_Details?.address !=null && dvs_Details?.address !=''){
        var exaddress = dvs_Details?.address;
    }
    // Set address mask
    var MaskAddress = '';
    if(dvs_Details?.address_manually == false){ 
        if(exaddress !=''){
            var MaskAddress = '1';
        }
    }


    var IsManualAd = false;
    if(dvs_Details?.address_manually === true){
       var IsManualAd = true;
    }


    var state_license = '';
     if(dvs_Details?.state_of_driving_license !== '' || dvs_Details?.state_of_driving_license !== null){
       var state_license = dvs_Details?.state_of_driving_license;
    }


    const [isBusinessCustomer, setIsBusinessCustomer] = useState(false);
    const [loading, setLoading] = useState(false);
    const [salutations, setSalutations] = useState([]);
    const [genderOptions, setGenderOptions] = useState([]);
    const [selectedIdType, setSelectedIdType] = useState(id_type);
    const [error, setError] = useState('');
    const [idImage, setIdImage] = useState('');
    const [idTypes , setIdType] = useState([]);
    const [licenseState, setLicenseState] = useState(state_license)
    const [expiryDate, setExpiryDate] = useState(null);
    const [addressmask, setAddressMask] = useState(MaskAddress);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalMessage, setModalMessage] = useState('');
    const [addressFull, setAddressFull] = useState(exaddress);
    const [isManualAddress, setIsManualAddress] = useState(IsManualAd);
 

    const [errors, setErrors] = useState({});

    const [medicareColors, setMdColors] = useState([]);
    const [aus_states, setAusStates] = useState([]);
    const [countries, setCountries] = useState([]);
    const [drivingStates, setDrivingStates] = useState([]);

    const [formData, setFormData] = useState({
        id_type: dvs_Details?.id_type || '',
        state_of_driving_license: dvs_Details?.state_of_driving_license || '',
        driving_license_no: dvs_Details?.driving_license_no || '',
        license_card_no: dvs_Details?.license_card_no || '',
        passport_number: dvs_Details?.passport_number || '',
        country_of_issue: dvs_Details?.country_of_issue || '',
        country_name: dvs_Details?.country_name || '',
        medicare_card_number: dvs_Details?.medicare_card_number || '',
        individual_reference_number: dvs_Details?.individual_reference_number || '',
        middle_name_on_card: dvs_Details?.middle_name_on_card || '',
        date_of_expiry: dvs_Details?.date_of_expiry || '',
        card_color: dvs_Details?.card_color || '',
        title: dvs_Details?.title || '',
        first_name: dvs_Details?.first_name || '',
        middle_name: dvs_Details?.middle_name || '',
        last_name: dvs_Details?.last_name || '',
        date_of_birth: dvs_Details?.date_of_birth || '',
        gender: dvs_Details?.gender || '',
        business_customer_check: dvs_Details?.business_customer_check || false,
        company_name: dvs_Details?.company_name || '',
        trading_name: dvs_Details?.trading_name || '',
        acn_number: dvs_Details?.acn_number || '',
        abn_number: dvs_Details?.abn_number || '',
        address: dvs_Details?.address || '',
        address_manually: dvs_Details?.address_manually || false,
        unit_number: dvs_Details?.unit_number || '',
        street_number: dvs_Details?.street_number || '',
        street_name: dvs_Details?.street_name || '',
        suburb: dvs_Details?.suburb || '',
        post_code: dvs_Details?.post_code || '',
        state: dvs_Details?.state || ''
       
    });



    const mindob = new Date(new Date().setFullYear(new Date().getFullYear() - 16));

    const toggleAddressFields = (e) => {
        let isChecked = e.target.checked;
        setIsManualAddress(isChecked);
        setFormData({ ...formData, address_manually: isChecked })

    };

    const setAddressFinder = (addressFull, address) => {
        setAddressFull(addressFull);
        setFormData({ ...formData, address: addressFull })
        setAddressMask('1');
    };

    const clearAddress = () => {
        setAddressMask('');
        setAddressFull('');
    };


    const AddressFinder = ({ addressFinderKey, inputClassName, id, onChange }) => {
        return (
            <WidgetInput
                addressFinderKey={addressFinderKey}
                inputClassName={inputClassName}
                id={id}
                onSelected={(fullAddress, address) => {
                    onChange(fullAddress, address);
                }}
            />
        );
    }



    const handleCheckboxChange = (event) => {
        setIsBusinessCustomer(event.target.checked);
    };

    const handleLicenseStateChange = (event) => {
        if (event.target.value === "") {
            setIdImage('')
        }
        setFormData({ ...formData, state_of_driving_license: event.target.value })
        setLicenseState(event.target.value);
        getIdImage(2, event.target.value);
    };

    const IsAlphaNumeric = (event) => {
        const charCode = event.which ? event.which : event.keyCode;
        if (
            !(charCode > 47 && charCode < 58) &&
            !(charCode > 64 && charCode < 91) &&
            !(charCode > 96 && charCode < 123)
        ) {
            event.preventDefault();
            return false;
        }
        return true;
    };

    const isMediNumber = (event) => {
        const charCode = event.which ? event.which : event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
            return false;
        }
        return true;
    };

    const isMediRefNumber = (event) => {
        const charCode = event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    };



    const handleIdTypeChange = (event) => {
        const selectedType = event.target.value;
        setSelectedIdType(selectedType);

        let key;
        let updatedFormData = { ...formData };

        if (selectedType === "passport") {
            key = 1;
            updatedFormData.id_type = "1";
        } else if (selectedType === "medicare") {
            key = 3;
            updatedFormData.id_type = "3";
        } else if (selectedType === "driving") {
            key = 2;
            updatedFormData.id_type = "2";
        } else {
            key = selectedType;
        }

        setFormData(updatedFormData);

        if (key) {
            getIdImage(key,licenseState);
        }
    };


    const getIdImage = async (key, state=null) => {
        const headers = await getApiHeader();
        setLoading(true);
        try {


            console.log("=========================================");
            console.log(key);
            console.log(state);
            console.log(licenseState);
            console.log("=========================================");

            if(key === 2 || key === "2"){ 

                if(state === null || state ==='' || state ===""){

                    console.log('select any license state.');
                    setIdImage('');
                    setLoading(false);
                    return;
                }
            }



            const response = await axios.post(`${SERVER_URL}activation/get/id/validation/images`, {
                session_id: commonSession,
                id_type: key,
                state_value: state
            }, {
                headers: headers
            });

            if (key === 1) {
                const passportData = response.data.data.passport;
                if (passportData && passportData.length > 0) {
                    setIdImage(passportData[0].image);
                }
            }
            else if (key === 2) {
                const drivingLicenseData = response.data.data.driving
                if (drivingLicenseData && drivingLicenseData.length > 0) {
                    setIdImage(drivingLicenseData[0].image)
                }
            }
            else if (key === 3) {
                const medicareData = response.data.data.medicare;
                if (medicareData && medicareData.length > 0) {
                    setIdImage(medicareData[0].image);
                }
            }

            setLoading(false);
        } catch (error) {
            console.error("Error fetching ID validation images:", error);
            setLoading(false);
        }
    };



    const getFormData = async () => {
        setLoading(true);
        setError('');

        try {
            const headers = await getApiHeader();
            const response = await axios.post(
                `${SERVER_URL}activation/get/id/validation`,
                {
                    session_id: commonSession,
                },
                {
                    headers: headers,
                }
            );

            setSalutations(response.data.data.salutations)
            setGenderOptions(response.data.data.gender)
            setMdColors(response.data.data.medicare_color)
            setAusStates(response.data.data.aus_states)
            setCountries(response.data.data.country)
            setDrivingStates(response.data.data.state_of_driving_license)
            // setIdType(response.data.data.id_type)
            // console.log("idTypes----->",response.data.data.id_type);

            console.log('Response:', response.data);
        } catch (error) {
            console.log(error);
            console.error('Error checking reference number: Unknown error');
            setError(error.response?.data?.message || 'An error occurred');
        } finally {
            setLoading(false);
        }
    };

    const validateForm = () => {

        console.log("formData.id_type", formData.id_type);
        
        const newErrors = {};

        if (formData.id_type === '2') {
            if (!formData.state_of_driving_license.trim()) {
                newErrors.state_of_driving_license = 'State of Driving License is required.';
            }

            if (!formData.driving_license_no.trim()) {
                newErrors.driving_license_no = 'Driving License Number is required.';
            }

            if (!formData.license_card_no.trim()) {
                newErrors.license_card_no = 'License Card Number is required.';
            }
        }

        if (formData.id_type === '1') {
            if (!formData.passport_number.trim()) {
                newErrors.passport_number = 'Passport Number is required.';
            }

            if (!formData.country_of_issue.trim()) {
                newErrors.country_of_issue = 'Country of Issued of passport is required.';
            }


            if(formData.country_of_issue === 'other'){
                 
                if (!formData.country_name.trim()) {
                    newErrors.country_name = 'Country name Issued of passport is required.';
                }
                if (formData.country_name.length < 1 ) {
                    newErrors.country_name = 'Please enter a valid country name.';
                }

            }
        }

        if (formData.id_type === '3') {

            if (!formData.medicare_card_number.trim()) {
                newErrors.medicare_card_number = 'Medicare Card Number is required.';
            }


            if (!formData.individual_reference_number.trim()) {
                newErrors.individual_reference_number = 'Individual Reference Number is required.';
            }



            if (!formData.date_of_expiry.trim()) {
                newErrors.date_of_expiry = 'Date of Expiry is required.';
            }


            if (!formData.card_color.trim()) {
                newErrors.card_color = 'Card Color is required.';
            }
        }

        if (!formData.title.trim()) {
            newErrors.title = 'Title is required.';
        }

        if (!formData.first_name.trim()) {
            newErrors.first_name = 'First Name is required.';
        }

        if (!formData.last_name.trim()) {
            newErrors.last_name = 'Last Name is required.';
        }

        if (formData.business_customer_check && !formData.company_name.trim()) {
            newErrors.company_name = 'Company name is required.';
        }

        if (formData.business_customer_check && !formData.trading_name.trim()) {
            newErrors.trading_name = 'Trading name is required.';
        }

        if (formData.business_customer_check && !formData.acn_number.trim()) {
            newErrors.acn_number = 'ACN number is required.';
        }

        if (formData.business_customer_check && !formData.abn_number.trim()) {
            newErrors.abn_number = 'ABN number is required.';
        }

        if (!formData.date_of_birth) {
            newErrors.date_of_birth = 'Date of Birth is required.';
        }

        if (!formData.gender) {
            newErrors.gender = 'Gender is required.';
        }

        if (isManualAddress) {
            if (!formData.unit_number.trim()) {
                newErrors.unit_number = 'Unit Number is required.';
            }

            if (!formData.street_number.trim()) {
                newErrors.street_number = 'Street Number is required.';
            }

            if (!formData.street_name.trim()) {
                newErrors.street_name = 'Street Name is required.';
            }

            if (!formData.suburb.trim()) {
                newErrors.suburb = 'Suburb is required.';
            }

            if (!formData.post_code.trim() || !/^[0-9]{4}$/.test(formData.post_code)) {
                newErrors.post_code = 'Post Code is required and must be 4 digits.';
            }

            if (!formData.state) {
                newErrors.state = 'State is required.';
            }
        }else{
            if (!formData.address.trim()) {
                newErrors.address = 'Please Select Valid Address.';
            }
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        
        setLoading(true);

        if(formData.id_type =='' || formData.id_type ==null){
            swal("", "Please Select Valid ID Type" , "warning");
            setLoading(false);
            return;
        }

        const newErrors = validateForm();

        if(newErrors === false){
            setLoading(false);
            return;
        }


        setLoading(true);


        handleDvsEntry(formData);

        try {
            const headers = await getApiHeader();
            const formDataWithSession = { ...formData, session_id:commonSession };

            const response = await axios.post(
                `${SERVER_URL}activation/update/id/validation`,
                formDataWithSession,
                { headers }
            );

            console.log('API Response:', response);

            nextStep();

            setLoading(false);

        } catch (error) {
            console.error('Error calling the API:', error);

            if (error.response) {
                const apiErrors = error.response.data.message;

                if (typeof apiErrors === 'string') {

                    swal("", apiErrors , 'error');

                } else if (typeof apiErrors === 'object') {
                    const formattedErrors = {};
                    for (const field in apiErrors) {
                        formattedErrors[field] = apiErrors[field][0]; 
                    }

                    setErrors(formattedErrors);
                }

                setLoading(false);
                console.log("Error----->", errors);
            }
        } finally {
            setLoading(false); 
        }
    };


    useEffect(() => {
        getFormData();
        if(imageKey !== null && imageKey !== ''){
            getIdImage(imageKey, state_license);
        }
    }, []);

   







    return (
        <div>
            <DashboardLayout>
                <DashboardNavbar />
                <ActivationHead />
                <div className="formbold-main-wrapper add-plan-wrapper idValidationDiv">
                    <div className="formbold-form-wrapper add-plan-form pos-rel">

                        {loading === true && (
                            <Loader />
                        )}

                        <h6>Id Validation</h6>
                        <hr/>
                        <br/>
                        <div className='container'>

                            <div className='row'>
                                <form onSubmit={handleSubmit} className='add-plan-form' id="id-verify" autoComplete='off'>
                                    <div className="formbold-mb-5 formbold-pt-3">

                                        <label className="formbold-form-label formbold-form-label-2">Pick an ID Type  <span className="madate_mark">*</span></label>


                                        <div className="id-selection-container" >
                                            

                                            <div className="id-type-options">
                                                <label className={`id-box ${selectedIdType === 'driving' ? 'active' : ''}`}>
                                                    <input
                                                        type="radio"
                                                        value="driving"
                                                        checked={selectedIdType === 'driving'}
                                                        onChange={handleIdTypeChange}
                                                    />
                                                    <span>Australian Driver's License</span>
                                                </label>
                                                <label className={`id-box ${selectedIdType === 'passport' ? 'active' : ''}`}>
                                                    <input
                                                        type="radio"
                                                        value="passport"
                                                        checked={selectedIdType === 'passport'}
                                                        onChange={handleIdTypeChange}
                                                    />
                                                    <span>Passport</span>
                                                </label>
                                                {/* <label className={`id-box ${selectedIdType === 'medicare' ? 'active' : ''}`}>
                                                    <input
                                                        type="radio"
                                                        value="medicare"
                                                        checked={selectedIdType === 'medicare'}
                                                        onChange={handleIdTypeChange}
                                                    />
                                                    <span>Medicare</span>
                                                </label> */}
                                            </div>
                                            {idImage && (
                                                <div className="id-type-image-container">
                                                    <img
                                                        src={idImage}
                                                        className="id-image"
                                                        alt="Medicare"
                                                    />

                                                </div>
                                            )}
                                        </div>
                                        <div className="col-lg-6 businessBlock">
                                            <div className="formbold-mb-5 formbold-pt-3">
                                                <div className='business-customer checkpik'>
                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            name="business-checkbox"
                                                            id="business-checkbox"
                                                            checked={formData.business_customer_check}
                                                            onChange={(e) => setFormData({ ...formData, business_customer_check: e.target.checked })}
                                                        />

                                                        Business Customer
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        {formData.business_customer_check && (
                                            <div className="ad-mb-result business_customer_block">
                                                
                                                    <div className="col-lg-6">
                                                        <label className="formbold-form-label formbold-form-label-2">Company name <span className="madate_mark">*</span></label>
                                                        <input
                                                            type="text"
                                                            name="company_name"
                                                            id="company-name"
                                                            placeholder="Enter company name"
                                                            className={`formbold-form-input ${errors.company_name ? 'is-invalid' : ''}`} // Add error class
                                                            value={formData.company_name}
                                                            onChange={(e) => setFormData({ ...formData, company_name: e.target.value })}
                                                            maxLength="60"
                                                            autoComplete='off'
                                                        />
                                                        {errors.company_name && (
                                                            <div className="ad-mp-err">{errors.company_name}</div>
                                                        )}
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <label className="formbold-form-label formbold-form-label-2">Trading name <span className="madate_mark">*</span></label>
                                                        <input
                                                            type="text"
                                                            name="trading_name"
                                                            id="trading-name"
                                                            placeholder="Enter trading name"
                                                            className={`formbold-form-input ${errors.trading_name ? 'is-invalid' : ''}`} // Add error class
                                                            value={formData.trading_name}
                                                            onChange={(e) => setFormData({ ...formData, trading_name: e.target.value })}
                                                            maxLength="60"
                                                            autoComplete='off'
                                                        />
                                                        {errors.trading_name && (
                                                            <div className="ad-mp-err">{errors.trading_name}</div>
                                                        )}
                                                    </div>
                                                
                                                    <div className="col-lg-6">
                                                        <label className="formbold-form-label formbold-form-label-2">ACN number <span className="madate_mark">*</span></label>
                                                        <input
                                                            type="text"
                                                            name="acn_number"
                                                            id="acn-number"
                                                            placeholder="Enter ACN number"
                                                            className={`formbold-form-input ${errors.acn_number ? 'is-invalid' : ''}`} // Add error class
                                                            value={formData.acn_number}
                                                            onChange={(e) => setFormData({ ...formData, acn_number: e.target.value })}
                                                            maxLength="9"
                                                            onKeyDown={(event) => {
                                                                if (!/[0-9]/.test(event.key) && event.key !== "Backspace" && event.key !== "Tab") {
                                                                    event.preventDefault();
                                                                }
                                                            }}
                                                            autoComplete='off'
                                                        />
                                                        {errors.acn_number && (
                                                            <div className="ad-mp-err">{errors.acn_number}</div>
                                                        )}
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <label className="formbold-form-label formbold-form-label-2">ABN number <span className="madate_mark">*</span></label>
                                                        <input
                                                            type="text"
                                                            name="abn_number"
                                                            id="abn-number"
                                                            placeholder="Enter ABN number"
                                                            className={`formbold-form-input ${errors.abn_number ? 'is-invalid' : ''}`} // Add error class
                                                            value={formData.abn_number}
                                                            onChange={(e) => setFormData({ ...formData, abn_number: e.target.value })}
                                                            maxLength="11"
                                                             onKeyDown={(event) => {
                                                                if (!/[0-9]/.test(event.key) && event.key !== "Backspace" && event.key !== "Tab") {
                                                                    event.preventDefault();
                                                                }
                                                            }}
                                                            autoComplete='off'
                                                        />
                                                        {errors.abn_number && (
                                                            <div className="ad-mp-err">{errors.abn_number}</div>
                                                        )}
                                                    </div>
                                            </div>
                                        )}

                                        <br/>








                                        {selectedIdType === 'driving' && (
                                            <>
                                                <p className="padl-zero id-section-head">Australian Driver's License Fields</p>
                                                <div className="ad-mb-result id-section">
                                                    
                                                    <div className="col-lg-6">
                                                        <label className="formbold-form-label formbold-form-label-2">State of Driver's License <span className="madate_mark">*</span></label>
                                                        <select
                                                            name="driving_license_state"

                                                            className={`formbold-form-input ${errors.state_of_driving_license ? 'is-invalid' : ''}`}
                                                            value={formData.state_of_driving_license}
                                                            onChange={handleLicenseStateChange}
                                                        >
                                                                <option value="">Select State</option>
                                                               {drivingStates.map((drivestates) => (
                                                                    <option key={drivestates} value={drivestates}>
                                                                        {drivestates}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                        {errors.state_of_driving_license && (
                                                            <div className="ad-mp-err">{errors.state_of_driving_license}</div>
                                                        )}
                                                    </div>

                                                    <div className="col-lg-6">
                                                        <label className="formbold-form-label formbold-form-label-2">Australian Driver's License No <span className="madate_mark">*</span></label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter License Number"
                                                            className={`formbold-form-input ${errors.driving_license_no ? 'is-invalid' : ''}`}
                                                            name="license_no"
                                                            id="license_no"
                                                            pattern="[A-Za-z0-9]{5,20}"
                                                            title="Enter Valid Australian Driver's License No - Number & Letters Allowed"
                                                            maxLength={20}
                                                            onKeyDown={(event) => {
                                                                // Allow only alphanumeric characters
                                                                if (!/[A-Za-z0-9]/.test(event.key) && event.key !== "Backspace" && event.key !== "Tab") {
                                                                    event.preventDefault();
                                                                }
                                                            }}
                                                            onSelect={(event) => event.preventDefault()}
                                                            onCut={(event) => event.preventDefault()}
                                                            onCopy={(event) => event.preventDefault()}
                                                            onPaste={(event) => event.preventDefault()}
                                                            onDrag={(event) => event.preventDefault()}
                                                            onDrop={(event) => event.preventDefault()}
                                                            value={formData.driving_license_no}
                                                            onChange={(e) => setFormData({ ...formData, driving_license_no: e.target.value })}
                                                        // required
                                                        autoComplete='off'
                                                        />
                                                        {errors.driving_license_no && (
                                                            <div className="ad-mp-err">{errors.driving_license_no}</div>
                                                        )}

                                                    </div>

                                                    <div className="col-lg-6">
                                                        <label className="formbold-form-label formbold-form-label-2">License Card No <span className="madate_mark">*</span></label>
                                                        <input type="text" placeholder="Enter Card Number" className={`formbold-form-input ${errors.license_card_no ? 'is-invalid' : ''}`} value={formData.license_card_no} onChange={(e) => setFormData({ ...formData, license_card_no: e.target.value })}  autoComplete='off' />
                                                        {errors.license_card_no && (
                                                            <div className="ad-mp-err">{errors.license_card_no}</div>
                                                        )}
                                                    </div>
                                                </div>
                                            </>
                                        )}







                                        {selectedIdType === 'passport' && (
                                            <>
                                                <p className="padl-zero id-section-head">Passport Fields</p>
                                                <div className="ad-mb-result id-section">
                                                    <div className="col-lg-6">
                                                        <label className="formbold-form-label formbold-form-label-2">Passport Number <span className="madate_mark">*</span></label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter Passport Number"
                                                            className={`formbold-form-input ${errors.passport_number ? 'is-invalid' : ''}`}
                                                            name="passport_no"
                                                            id="passport_no"
                                                            pattern="[A-Za-z0-9]{5,20}"
                                                            title="Enter Valid Passport Number - Numbers & Letters Allowed"
                                                            maxLength="20"
                                                            onKeyDown={(event) => {
                                                                    if (!/[A-Za-z0-9]/.test(event.key) && event.key !== "Backspace" && event.key !== "Tab") {
                                                                        event.preventDefault();
                                                                    }
                                                                }}
                                                            onPaste={(e) => e.preventDefault()}
                                                            onCopy={(e) => e.preventDefault()}
                                                            onCut={(e) => e.preventDefault()}
                                                            onDrag={(e) => e.preventDefault()}
                                                            onDrop={(e) => e.preventDefault()}
                                                            // required
                                                            value={formData.passport_number}
                                                            onChange={(e) => setFormData({ ...formData, passport_number: e.target.value })}
                                                            autoComplete='off'
                                                        />
                                                        {errors.passport_number && (
                                                            <div className="ad-mp-err">{errors.passport_number}</div>
                                                        )}
                                                    </div>

                                                    <div className="col-lg-6">
                                                        <label className="formbold-form-label formbold-form-label-2">Country of Issue <span className="madate_mark">*</span></label>
                                                        <select name="passport_country" className={`formbold-form-input ${errors.country_of_issue ? 'is-invalid' : ''}`} value={formData.country_of_issue} onChange={(e) => setFormData({ ...formData, country_of_issue: e.target.value })}>
                                                            <option value="">Select Country</option>

                                                            {countries && Object.keys(countries).map((code) => (
                                                              <option key={code} value={code}>
                                                                {countries[code]}
                                                              </option>
                                                            ))}
                                                            <option value="other">Other</option>
                                                        </select>
                                                        {errors.country_of_issue && (
                                                            <div className="ad-mp-err">{errors.country_of_issue}</div>
                                                        )}
                                                    </div>

                                                    {formData.country_of_issue ==='other' && (
                                                         <div className="col-lg-6">
                                                            <label className="formbold-form-label formbold-form-label-2">Enter Country Name <span className="madate_mark">*</span></label>
                                                            <input
                                                             autoComplete="new-password"
                                                                type="text"
                                                                placeholder="Enter Country Name"
                                                                className={`formbold-form-input ${errors.country_name ? 'is-invalid' : ''}`}
                                                                name="country_name"
                                                                id="country_name"
                                                                pattern="[A-Za-z ]{1,20}"
                                                                title="Enter Valid Country Name - Letters Allowed"
                                                                maxLength={20}
                                                                onKeyDown={(event) => {
                                                                    // Allow only alphanumeric characters
                                                                    if (!/[A-Za-z0-9 ]/.test(event.key) && event.key !== "Backspace" && event.key !== "Tab") {
                                                                        event.preventDefault();
                                                                    }
                                                                }}
                                                                onSelect={(event) => event.preventDefault()}
                                                                onCut={(event) => event.preventDefault()}
                                                                onCopy={(event) => event.preventDefault()}
                                                                onPaste={(event) => event.preventDefault()}
                                                                onDrag={(event) => event.preventDefault()}
                                                                onDrop={(event) => event.preventDefault()}
                                                                value={formData.country_name}
                                                                onChange={(e) => setFormData({ ...formData, country_name: e.target.value })}
                                                            // required
                                                            />
                                                            {errors.country_name && (
                                                                <div className="ad-mp-err">{errors.country_name}</div>
                                                            )}

                                                        </div>
                                                    )}


                                                </div>
                                            </>
                                        )}







                                        {selectedIdType === 'medicare' && (
                                            <>
                                                <p className="padl-zero id-section-head">Medicare Fields</p>
                                                <div className="ad-mb-result id-section">

                                                    <div className="col-lg-6">
                                                        <label className="formbold-form-label formbold-form-label-2">Medicare Card Number <span className="madate_mark">*</span></label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter Card Number"
                                                            className={`formbold-form-input ${errors.medicare_card_number ? 'is-invalid' : ''}`}
                                                            name="medicare_no"
                                                            id="medicare_no"
                                                            pattern="[0-9]{10}"
                                                            title="Enter Valid Medicare Card Number - Only Numbers Allowed"
                                                            maxLength="10"
                                                            onKeyDown={(event) => {
                                                                    if (!/[0-9]/.test(event.key) && event.key !== "Backspace" && event.key !== "Tab") {
                                                                        event.preventDefault();
                                                                    }
                                                                }}
                                                            onPaste={(e) => e.preventDefault()}
                                                            onCopy={(e) => e.preventDefault()}
                                                            onCut={(e) => e.preventDefault()}
                                                            onDrag={(e) => e.preventDefault()}
                                                            onDrop={(e) => e.preventDefault()}
                                                            value={formData.medicare_card_number}
                                                            onChange={(e) => setFormData({ ...formData, medicare_card_number: e.target.value })}
                                                        // required
                                                        autoComplete='off'
                                                        />
                                                        {errors.medicare_card_number && (
                                                            <div className="ad-mp-err">{errors.medicare_card_number}</div>
                                                        ) }

                                                    </div>

                                                    <div className="col-lg-6">
                                                        <label className="formbold-form-label formbold-form-label-2">Individual Reference Number (IRN) <span className="madate_mark">*</span></label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter Individual Reference Number"
                                                            className={`formbold-form-input ${errors.individual_reference_number ? 'is-invalid' : ''}`}
                                                            name="medicare_refno"
                                                            id="medicare_refno"
                                                            pattern="[0-9]{1}"
                                                            title="Enter Valid Medicare Reference Number - Only Numbers Allowed"
                                                            maxLength="1"
                                                            onKeyDown={(event) => {
                                                                    if (!/[0-9]/.test(event.key) && event.key !== "Backspace" && event.key !== "Tab") {
                                                                        event.preventDefault();
                                                                    }
                                                                }}
                                                            onPaste={(e) => e.preventDefault()}
                                                            onCopy={(e) => e.preventDefault()}
                                                            onCut={(e) => e.preventDefault()}
                                                            onDrag={(e) => e.preventDefault()}
                                                            onDrop={(e) => e.preventDefault()}
                                                            value={formData.individual_reference_number}
                                                            onChange={(e) => setFormData({ ...formData, individual_reference_number: e.target.value })}
                                                        // required
                                                        autoComplete='off'
                                                        />
                                                        {errors.individual_reference_number && (
                                                            <div className="ad-mp-err">{errors.individual_reference_number}</div>
                                                        )  }
                                                    </div>

                                                    <div className="col-lg-6">
                                                        <label className="formbold-form-label formbold-form-label-2">Middle Name On Card</label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter Middle Name On Card"
                                                            className={`formbold-form-input ${errors.middle_name_on_card ? 'is-invalid' : ''}`}
                                                            name="medicare_middle_name"
                                                            id="medicare_middle_name"
                                                            maxLength="40"
                                                            onKeyDown={(event) => /^[a-zA-Z]*$/.test(event.key) || event.preventDefault()}
                                                            onPaste={(e) => e.preventDefault()}
                                                            onCopy={(e) => e.preventDefault()}
                                                            onCut={(e) => e.preventDefault()}
                                                            onDrag={(e) => e.preventDefault()}
                                                            onDrop={(e) => e.preventDefault()}
                                                            value={formData.middle_name_on_card}
                                                            onChange={(e) => setFormData({ ...formData, middle_name_on_card: e.target.value })}
                                                            autoComplete='off'

                                                        />
                                                        {errors.middle_name_on_card && (
                                                            <div className="ad-mp-err">{errors.middle_name_on_card}</div>
                                                        )  }

                                                    </div>

                                                    
                                                    <div className="col-lg-6">
                                                        <label className="formbold-form-label formbold-form-label-2">
                                                            Date of Expiry <span className="madate_mark">*</span>
                                                        </label>
                                                        <div className="medicareDate">
                                                            <DatePicker
                                                                selected={formData.date_of_expiry}
                                                                 onChange={(date) => {
                                                                   // const formattedDate = date ? date.toISOString().split('T')[0] : '';
                                                                    const formattedDate = date ? date.toLocaleDateString('en-CA') : '';
                                                                    setFormData({ ...formData, date_of_expiry: formattedDate })
                                                                   
                                                                }}
                                                                className={`formbold-form-input ${errors.date_of_expiry ? 'is-invalid' : ''}`}

                                                                dateFormat="yyyy-MM-dd"
                                                                placeholderText="Select Expiry Date"
                                                                minDate={new Date()}
                                                                autoComplete="off" 
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                scrollableYearDropdown
                                                                yearDropdownItemNumber={100}
                                                                // required
                                                                wrapperClassName=" w-full"
                                                                onKeyDown={(e) => e.preventDefault()}
                                                                onKeyUp={(e) => e.preventDefault()}
                                                                onPaste={(e) => e.preventDefault()}
                                                                onCopy={(e) => e.preventDefault()}
                                                                onCut={(e) => e.preventDefault()}
                                                                onDrag={(e) => e.preventDefault()}
                                                                onDrop={(e) => e.preventDefault()}
                                                            />
                                                        </div>
                                                        {errors.date_of_expiry && (
                                                            <div className="ad-mp-err">{errors.date_of_expiry}</div>
                                                        )}
                                                    </div>

                                                    <div className="col-lg-6">
                                                        <label className="formbold-form-label formbold-form-label-2">Card Color <span className="madate_mark">*</span></label>
                                                        <select name="medicare_card_color" className={`formbold-form-input ${errors.card_color ? 'is-invalid' : ''}`} value={formData.card_color} onChange={(e) => setFormData({ ...formData, card_color: e.target.value })}>
                                                            <option value="">Select Colour</option>
                                                            {medicareColors && Object.keys(medicareColors).map((colorCode) => (
                                                              <option key={colorCode} value={colorCode}>
                                                                {medicareColors[colorCode]}
                                                              </option>
                                                            ))}
                                                        </select>
                                                        {errors.card_color && (
                                                            <div className="ad-mp-err">{errors.card_color}</div>
                                                        )}
                                                    </div>
                                                    
                                                </div>
                                            </>
                                        )}

                                        

                                        <br/>


                                        <div className="ad-mb-result">

                                            <div className="col-lg-6">
                                                <label className="formbold-form-label formbold-form-label-2">Title <span className="madate_mark">*</span> </label>

                                                <select
                                                    name="sal"
                                                    id="email"
                                                    className={`formbold-form-input ${errors.title ? 'is-invalid' : ''}`}
                                                    value={formData.title}
                                                    onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                                                >
                                                    <option value="">Select A Value</option>

                                                    {salutations.map((salutation) => (
                                                        <option key={salutation} value={salutation}>
                                                            {salutation}
                                                        </option>
                                                    ))}

                                                </select>

                                                {errors.title && (
                                                    <div className="ad-mp-err">{errors.title}</div>
                                                )}
                                            </div>



                                            <div className="col-lg-6">
                                                <label className="formbold-form-label formbold-form-label-2">First Name <span className="madate_mark">*</span></label>
                                                <input
                                                   autoComplete="new-password"
                                                    type="text"
                                                    name="first-name"
                                                    id="first-name"
                                                    placeholder="Enter First name"
                                                    className={`formbold-form-input ${errors.first_name ? 'is-invalid' : ''}`}
                                                    value={formData.first_name}
                                                    maxLength={30}
                                                    onKeyDown={(event) => {
                                                        if (!/[A-Za-z ]/.test(event.key) && event.key !== "Backspace" && event.key !== "Tab") {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                    onChange={(e) => setFormData({ ...formData, first_name: e.target.value })}
                                                    
                                                />
                                                {errors.first_name && (
                                                    <div className="ad-mp-err">{errors.first_name}</div>
                                                )}
                                            </div>




                                            {/* Middle Name Field */}
                                            <div className="col-lg-6">
                                                <label className="formbold-form-label formbold-form-label-2">Middle Name</label>
                                                <input
                                                    autoComplete="new-password"
                                                    type="text"
                                                    name="middle-name"
                                                    id="middle-name"
                                                    placeholder="Enter Middle name"
                                                    className={`formbold-form-input ${errors.middle_name ? 'is-invalid' : ''}`}
                                                    value={formData.middle_name}
                                                    maxLength={30}
                                                    onKeyDown={(event) => {
                                                        if (!/[A-Za-z ]/.test(event.key) && event.key !== "Backspace" && event.key !== "Tab") {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                    onChange={(e) => setFormData({ ...formData, middle_name: e.target.value })}

                                                />
                                                {errors.middle_name && (
                                                    <div className="ad-mp-err">{errors.middle_name}</div>
                                                ) }
                                            </div>

                                            {/* Last Name Field */}
                                            <div className="col-lg-6">
                                                <label className="formbold-form-label formbold-form-label-2">Last Name <span className="madate_mark">*</span></label>
                                                <input
                                                   autoComplete="new-password"
                                                    type="text"
                                                    name="last-name"
                                                    id="last-name"
                                                    placeholder="Enter Last name"
                                                    className={`formbold-form-input ${errors.last_name ? 'is-invalid' : ''}`}
                                                    value={formData.last_name}
                                                    maxLength={30}
                                                    onKeyDown={(event) => {
                                                        if (!/[A-Za-z ]/.test(event.key) && event.key !== "Backspace" && event.key !== "Tab") {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                    onChange={(e) => setFormData({ ...formData, last_name: e.target.value })}
                                                    
                                                />
                                                {errors.last_name &&(
                                                    <div className="ad-mp-err">{errors.last_name}</div>
                                                ) }
                                            </div>

                                            {/* Date of Birth Field */}
                                            <div className="col-lg-6">
                                                <label className="formbold-form-label formbold-form-label-2">Date of Birth <span className="madate_mark">*</span></label>
                                                
                                              

                                                 <DatePicker
                                                    selected={formData.date_of_birth}
                                                    onChange={(date) => {
                                                       
                                                       // const formattedDate = date ? date.toISOString().split('T')[0] : '';
                                                        const formattedDate = date ? date.toLocaleDateString('en-CA') : '';
                                                        setFormData({ ...formData, date_of_birth: formattedDate })
                                                       
                                                    }}
                                                    dateFormat="yyyy-MM-dd"
                                                    placeholderText="Enter Date of Birth"
                                                    className={`formbold-form-input addInput empty_marleft ${errors.date_of_birth ? 'is-invalid' : ''}`}
                                                    wrapperClassName="date-picker-wrapper"
                                                    id="date"
                                                    name="date"
                                                    autoComplete="off" 
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    scrollableYearDropdown
                                                    yearDropdownItemNumber={100}
                                                    maxDate={new Date(new Date().setFullYear(new Date().getFullYear() - 18))} // Set minimum age to 18
                                                    onKeyDown={(e) => e.preventDefault()}
                                                    onKeyUp={(e) => e.preventDefault()}
                                                    onPaste={(e) => e.preventDefault()}
                                                    onCopy={(e) => e.preventDefault()}
                                                    onCut={(e) => e.preventDefault()}
                                                    onDrag={(e) => e.preventDefault()}
                                                    onDrop={(e) => e.preventDefault()}

                                                />



                                                {errors.date_of_birth && (
                                                    <div className="ad-mp-err">{errors.date_of_birth}</div>
                                                )  }
                                            </div>

                                            {/* Gender Field */}
                                            <div className="col-lg-6">
                                                <label className="formbold-form-label formbold-form-label-2">Gender <span className="madate_mark">*</span></label>
                                                <select
                                                    name="gender"
                                                    id="gender"
                                                    className={`formbold-form-input ${errors.gender ? 'is-invalid' : ''}`}
                                                    value={formData.gender}
                                                    onChange={(e) => setFormData({ ...formData, gender: e.target.value })}
                                                >
                                                    <option value="">Select Gender</option>
                                                    {genderOptions.map((genderOption) => (
                                                        <option key={genderOption} value={genderOption}>
                                                            {genderOption}
                                                        </option>
                                                    ))}

                                                </select>
                                                {errors.gender && (
                                                    <div className="ad-mp-err">{errors.gender}</div>
                                                ) }
                                            </div>







                                            <div className="col-lg-12">
                                                
                                                {isManualAddress ? (
                                                    <>
                                                        <div className='row manualrow'>
                                                            <div className="col-md-6">
                                                                <label className='formbold-form-label formbold-form-label-2'>
                                                                    Unit Number <span className="madate_mark">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className={`formbold-form-input ${errors.unit_number ? 'is-invalid' : ''}`}
                                                                    placeholder="Enter Unit Number"
                                                                    id="unit_number"
                                                                    name="unit_number"
                                                                    maxLength="20"
                                                                    value={formData.unit_number}
                                                                    onChange={(e) => setFormData({ ...formData, unit_number: e.target.value })}
                                                                    autoComplete="new-password"
                                                                />
                                                                {errors.unit_number && (
                                                                    <div className="ad-mp-err">{errors.unit_number}</div>
                                                                ) }
                                                            </div>
                                                            <div className="col-md-6">
                                                                <label className='formbold-form-label formbold-form-label-2'>
                                                                    Street Number <span className="madate_mark">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className={`formbold-form-input ${errors.street_number ? 'is-invalid' : ''}`}
                                                                    placeholder="Enter Street Number"
                                                                    id="street_number"
                                                                    name="street_number"
                                                                    maxLength="20"
                                                                    value={formData.street_number}
                                                                    onChange={(e) => setFormData({ ...formData, street_number: e.target.value })}
                                                                    autoComplete="new-password"
                                                                />
                                                                {errors.street_number && (
                                                                    <div className="ad-mp-err">{errors.street_number}</div>
                                                                ) }
                                                            </div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className="col-md-6">
                                                                <label className='formbold-form-label formbold-form-label-2'>
                                                                    Street Name <span className="madate_mark">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className={`formbold-form-input ${errors.street_name ? 'is-invalid' : ''}`}
                                                                    placeholder="Enter Street Name"
                                                                    id="street_name"
                                                                    name="street_name"
                                                                    maxLength="40"
                                                                    value={formData.street_name}
                                                                    onChange={(e) => setFormData({ ...formData, street_name: e.target.value })}
                                                                    autoComplete="new-password"
                                                                />
                                                                {errors.street_name && (
                                                                    <div className="ad-mp-err">{errors.street_name}</div>
                                                                )   }
                                                            </div>

                                                            <div className="col-md-6">
                                                                <label className='formbold-form-label formbold-form-label-2'>
                                                                    Suburb <span className="madate_mark">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className={`formbold-form-input ${errors.suburb ? 'is-invalid' : ''}`}
                                                                    placeholder="Enter Suburb"
                                                                    id="suburb"
                                                                    name="suburb"
                                                                    value={formData.suburb}
                                                                    onChange={(e) => setFormData({ ...formData, suburb: e.target.value })}
                                                                    autoComplete="new-password"
                                                                />
                                                                {errors.suburb && (
                                                                    <div className="ad-mp-err">{errors.suburb}</div>
                                                                ) }
                                                            </div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className="col-md-6">
                                                                <label className='formbold-form-label formbold-form-label-2'>
                                                                    Post code <span className="madate_mark">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className={`formbold-form-input ${errors.post_code ? 'is-invalid' : ''}`}
                                                                    placeholder="Enter Post code"
                                                                    id="post_code"
                                                                    name="post_code"
                                                                    maxLength="4"
                                                                    pattern="[0-9]{4}"
                                                                    value={formData.post_code}
                                                                    onChange={(e) => setFormData({ ...formData, post_code: e.target.value })}
                                                                    autoComplete="new-password"
                                                                />
                                                                {errors.post_code && (
                                                                    <div className="ad-mp-err">{errors.post_code}</div>
                                                                )   }
                                                            </div>

                                                            <div className="col-md-6">
                                                                <label className='formbold-form-label formbold-form-label-2'>
                                                                    State <span className="madate_mark">*</span>
                                                                </label>
                                                                <select
                                                                    className={`formbold-form-input selectpicker1 ${errors.state ? 'is-invalid' : ''}`}
                                                                    id="state"
                                                                    name="state"
                                                                    value={formData.state}
                                                                    onChange={(e) => setFormData({ ...formData, state: e.target.value })}
                                                                >
                                                                    <option value="">Select State</option>
                                                                    {aus_states.map((austates) => (
                                                                        <option key={austates} value={austates}>
                                                                            {austates}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                                {errors.state && (
                                                                    <div className="ad-mp-err">{errors.state}</div>
                                                                )  }
                                                            </div>
                                                        </div>
                                                    </>

                                                ) : (

                                                    <div className="row">
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                                <br></br>
                                                                <label className='formbold-form-label formbold-form-label-2'>Select Address <span className="madate_mark">*</span></label>

                                                                {addressmask === '' &&
                                                                    <AddressFinder
                                                                        addressFinderKey="UJCFN4HL6YRMT3D9K8PG"
                                                                        inputClassName={`formbold-form-input selectpicker1 ${errors.address ? 'is-invalid' : ''}`}
                                                                        id="address"
                                                                        placeholder="Enter unit/house/building number and street address"
                                                                        onChange={setAddressFinder}
                                                                    />
                                                                }

                                                                {addressmask === '1' &&
                                                                    <div className="address-input-container">
                                                                        <input
                                                                            type="text"
                                                                            className={`formbold-form-input address-form-control selectpicker1 ${errors.address ? 'is-invalid' : ''}`}

                                                                            // className="form-control  p-3"
                                                                            value={formData.address}
                                                                            placeholder="Enter your Address"
                                                                            disabled
                                                                            autoComplete="new-password"
                                                                        />
                                                                        <span className="clearaddress-icon clearInput" onClick={clearAddress}><i class="fa fa-refresh" aria-hidden="true"></i> Reset Address</span>

                                                                    </div>

                                                                }
                                                                {errors.address && (
                                                                    <div className="ad-mp-err">{errors.address}</div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}


                                                <div className="padl-zero checkpik">
                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            className="input-text manualcheckbox"
                                                            onChange={toggleAddressFields}
                                                            checked={isManualAddress}
                                                        />

                                                        Enter Address Manually
                                                    </label>
                                                </div>

                                            </div>


                                           
                                           





                                        </div>



                                   

                                   </div> 


                                    <br></br>
                                    <div className="button-container add-mb-button-container">
                                        <button type="button" onClick={prevStep} className="button btn btn-danger">
                                            Back
                                        </button>

                                        <button type="submit" className="button btn btn-danger ad-mb-button-next">
                                            Verify & Continue
                                        </button>
                                    </div>


                                </form>
                                
                            </div>
                        </div>
                    </div>
                </div >
                
            </DashboardLayout >
        </div >
    )
}

export default IdValidation